<div class="cm-login-container">
    @let showProgressCircle = $showProgressCircle();
    @let forgotPassword = $forgotPassword();
    @let passwordToken = $passwordToken();
    @let isWelcomeFlow = $isWelcomeFlow();
    @let microsoftSsoLink = $microsoftSsoLink();
    @let googleSsoLink = $googleSsoLink();
    <!--login page-->
    @if (!forgotPassword && passwordToken === undefined) {
        <div class="cm-login-and-register">
            <div class="cm-login-card">
                <div class="cm-login-card-header">Log in to colormass</div>
                <div class="cm-login-options">
                    @if (!showProgressCircle) {
                        <div class="cm-login-card-bottom">
                            @if (microsoftSsoLink) {
                                <a class="cm-sign-in-with-microsoft" [href]="microsoftSsoLink"
                                    ><img class="cm-microsoft-logo" alt="Microsoft logo" ngSrc="assets/images/Microsoft.svg" width="21" height="21" />Sign in
                                    with Microsoft</a
                                >
                            }
                            @if (googleSsoLink) {
                                <a class="cm-sign-in-with-google" [href]="googleSsoLink"
                                    ><img class="cm-google-logo" alt="Google logo" ngSrc="assets/images/Google.png" width="20" height="20" />Sign in with
                                    Google</a
                                >
                            }
                        </div>
                    }

                    <div class="cm-or">or</div>

                    <form class="cm-login-form" name="loginForm" [formGroup]="loginForm" novalidate (ngSubmit)="login()">
                        <cm-input-container
                            [matTooltip]="
                                loginForm.controls.loginEmailFormControl.hasError('email') || loginForm.controls.loginEmailFormControl.hasError('required')
                                    ? 'Please enter a valid email address'
                                    : ''
                            "
                            [warning]="
                                loginForm.controls.loginEmailFormControl.hasError('email') || loginForm.controls.loginEmailFormControl.hasError('required')
                            "
                        >
                            <ng-container cm-top-label>
                                <div class="cm-top-label">Email:</div>
                            </ng-container>
                            <ng-container cm-input>
                                <input
                                    placeholder="Enter email"
                                    name="email"
                                    formControlName="loginEmailFormControl"
                                    autofocus
                                    class="cm-email"
                                    autocomplete="email"
                                />
                            </ng-container>
                        </cm-input-container>
                        <cm-input-container
                            [matTooltip]="loginForm.controls.loginPasswordFormControl.hasError('required') ? 'Password is required' : ''"
                            [warning]="loginForm.controls.loginPasswordFormControl.hasError('required')"
                        >
                            <ng-container cm-top-label>
                                <div class="cm-top-label">Password:</div>
                            </ng-container>
                            <ng-container cm-input>
                                <input
                                    placeholder="Enter password"
                                    matInput
                                    type="password"
                                    name="password"
                                    formControlName="loginPasswordFormControl"
                                    class="cm-password"
                                    autocomplete="current-password"
                                />
                            </ng-container>
                        </cm-input-container>
                        @if (!showProgressCircle) {
                            <button
                                class="cm-sign-in-button"
                                type="submit"
                                [disabled]="showProgressCircle || !loginForm.valid"
                                [class.cm-active]="loginForm.valid"
                            >
                                <i class="far fa-sign-in"></i>
                                <span>Log in</span>
                            </button>
                            <a class="cm-reset-password" (click)="$forgotPassword.set(true)">Forgot password?</a>

                            <div class="cm-legal-container">
                                When using the colormass platform you agree to the
                                <a class="cm-legal" href="https://www.colormass.com/legal/terms-of-service" target="_blank">colormass Terms of Service</a>.
                            </div>
                        }
                    </form>
                    @if (showProgressCircle) {
                        <mat-progress-spinner mode="indeterminate" [diameter]="24" color="primary"></mat-progress-spinner>
                    }
                </div>
            </div>
            <div class="cm-sign-up-container">
                Don't have an account?
                <a class="cm-register-button" href="/95ngsj3e/sign-up">Sign up</a>
            </div>
        </div>
    }
    <!--forgot password page-->
    @if (forgotPassword && passwordToken === undefined) {
        <div class="cm-login-card">
            <div class="cm-login-card-header">Forgot Password</div>
            <form
                class="cm-login-form"
                name="forgotPasswordForm"
                [formGroup]="forgotPasswordForm"
                novalidate
                (ngSubmit)="sendForgotPasswordEmail(forgotPasswordForm.controls.passwordResetEmailFormControl.value)"
            >
                <cm-input-container
                    [matTooltip]="forgotPasswordForm.controls.passwordResetEmailFormControl.hasError('required') ? 'Email is required' : ''"
                    [warning]="forgotPasswordForm.controls.passwordResetEmailFormControl.hasError('required')"
                >
                    <ng-container cm-top-label>
                        <div class="cm-top-label">Email:</div>
                    </ng-container>
                    <ng-container cm-input>
                        <input
                            placeholder="Enter email"
                            name="email"
                            formControlName="passwordResetEmailFormControl"
                            class="cm-email"
                            autofocus
                            autocomplete="email"
                        />
                    </ng-container>
                </cm-input-container>
                <button
                    class="cm-sign-in-button"
                    type="submit"
                    [disabled]="showProgressCircle || !forgotPasswordForm.valid"
                    [class.cm-active]="!showProgressCircle && forgotPasswordForm.valid"
                >
                    Reset Password
                </button>
            </form>
            @if (showProgressCircle) {
                <mat-progress-spinner mode="indeterminate" [diameter]="24" color="primary"></mat-progress-spinner>
            } @else {
                @if (googleSsoLink || microsoftSsoLink) {
                    <div class="cm-or">or</div>
                    <div class="cm-login-form">
                        @if (microsoftSsoLink) {
                            <a class="cm-sign-in-with-microsoft" [href]="microsoftSsoLink"
                                ><img class="cm-microsoft-logo" alt="Microsoft logo" ngSrc="assets/images/Microsoft.svg" width="21" height="21" />Sign in with
                                Microsoft</a
                            >
                        }
                        @if (googleSsoLink) {
                            <a class="cm-sign-in-with-google" [href]="googleSsoLink"
                                ><img class="cm-google-logo" alt="Google logo" ngSrc="assets/images/Google.png" width="20" height="20" />Sign in with Google</a
                            >
                        }
                    </div>
                }
                <a class="cm-back" (click)="$forgotPassword.set(false)"><i class="fa-regular fa-chevron-left"></i> Back to Login</a>
            }
        </div>
    }
    <!--reset password page-->
    @if (!forgotPassword && passwordToken != undefined) {
        @let passwordsMatch = passwordResetForm.controls.passwordVariantOneFormControl.value === passwordResetForm.controls.passwordVariantTwoFormControl.value;
        @let submitAttempted = $passwordSubmitAttempted();
        <div class="cm-login-card">
            <div class="cm-login-card-header">{{ $cardHeading() }}</div>
            <form class="cm-login-form" name="passwordResetForm" [formGroup]="passwordResetForm" novalidate (ngSubmit)="onSubmitPassword()">
                @if (isWelcomeFlow) {
                    <cm-input-container
                        [matTooltip]="passwordResetForm.controls.firstNameFormControl.hasError('required') ? 'First name is required' : ''"
                        [warning]="passwordResetForm.controls.firstNameFormControl.hasError('required')"
                    >
                        <ng-container cm-top-label>
                            <div class="cm-top-label">First name:</div>
                        </ng-container>
                        <ng-container cm-input>
                            <input
                                placeholder="Enter first name"
                                name="firstName"
                                formControlName="firstNameFormControl"
                                class="cm-email"
                                autocomplete="given-name"
                                autofocus
                            />
                        </ng-container>
                    </cm-input-container>

                    <cm-input-container
                        [matTooltip]="passwordResetForm.controls.lastNameFormControl.hasError('required') ? 'Last name is required' : ''"
                        [warning]="passwordResetForm.controls.lastNameFormControl.hasError('required')"
                    >
                        <ng-container cm-top-label>
                            <div class="cm-top-label">Last name:</div>
                        </ng-container>
                        <ng-container cm-input>
                            <input
                                placeholder="Enter last name"
                                name="lastName"
                                formControlName="lastNameFormControl"
                                class="cm-email"
                                autocomplete="family-name"
                            />
                        </ng-container>
                    </cm-input-container>
                }

                <cm-input-container
                    [matTooltip]="
                        submitAttempted && passwordResetForm.controls.passwordVariantOneFormControl.hasError('required')
                            ? 'Field is required'
                            : submitAttempted && passwordResetForm.controls.passwordVariantOneFormControl.hasError('minlength')
                              ? 'Password must be at least 8 characters'
                              : ''
                    "
                    [warning]="
                        submitAttempted &&
                        (passwordResetForm.controls.passwordVariantOneFormControl.hasError('required') ||
                            passwordResetForm.controls.passwordVariantOneFormControl.hasError('minlength'))
                    "
                >
                    <ng-container cm-top-label>
                        <div class="cm-top-label">Password:</div>
                    </ng-container>
                    <ng-container cm-input>
                        <input
                            type="password"
                            placeholder="Enter password"
                            name="passwordVariantOne"
                            required
                            formControlName="passwordVariantOneFormControl"
                            [attr.autofocus]="isWelcomeFlow ? null : ''"
                            class="cm-password"
                            autocomplete="new-password"
                    /></ng-container>
                </cm-input-container>
                <cm-input-container
                    [matTooltip]="
                        submitAttempted && passwordResetForm.controls.passwordVariantTwoFormControl.hasError('required')
                            ? 'Field is required'
                            : submitAttempted && !passwordsMatch
                              ? 'Passwords do not match'
                              : ''
                    "
                    [warning]="submitAttempted && (passwordResetForm.controls.passwordVariantTwoFormControl.hasError('required') || !passwordsMatch)"
                >
                    <ng-container cm-top-label>
                        <div class="cm-top-label">Retype password:</div>
                    </ng-container>
                    <ng-container cm-input>
                        <input
                            type="password"
                            placeholder="Enter Password"
                            formControlName="passwordVariantTwoFormControl"
                            name="passwordVariantTwo"
                            required
                            class="cm-password"
                            autocomplete="new-password"
                    /></ng-container>
                </cm-input-container>
                @if (submitAttempted && passwordResetForm.controls.passwordVariantOneFormControl.hasError("minlength")) {
                    <div class="cm-password-error">Password must be at least 8 characters</div>
                }
                @if (submitAttempted && !passwordsMatch) {
                    <div class="cm-password-error">Passwords do not match</div>
                }
                <button type="submit" class="cm-sign-in-button" [class.cm-active]="!showProgressCircle" [disabled]="showProgressCircle">
                    Complete Registration
                </button>
            </form>
            @if (showProgressCircle) {
                <mat-progress-spinner mode="indeterminate" [diameter]="24" color="primary"></mat-progress-spinner>
            } @else {
                @if (googleSsoLink || microsoftSsoLink) {
                    <div class="cm-sign-in-alternative">or</div>
                    <div class="cm-login-form">
                        @if (microsoftSsoLink) {
                            <a class="cm-sign-in-with-microsoft" [href]="microsoftSsoLink"
                                ><img class="cm-microsoft-logo" alt="Microsoft logo" ngSrc="assets/images/Microsoft.svg" width="21" height="21" />Sign in with
                                Microsoft</a
                            >
                        }
                        @if (googleSsoLink) {
                            <a class="cm-sign-in-with-google" [href]="googleSsoLink"
                                ><img class="cm-google-logo" alt="Google logo" ngSrc="assets/images/Google.png" width="20" height="20" />Sign in with Google</a
                            >
                        }
                    </div>
                }
                <a class="cm-back" (click)="$forgotPassword.set(false)"><i class="fa-regular fa-chevron-left"></i> Back to Login</a>
            }
        </div>
    }
    <!--reset password page-->
</div>
